import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DateHelper } from '../../models/NgDateCustomAdapter';

@Component({
  selector: 'app-file-temporal-browser',
  templateUrl: './file-temporal-browser.component.html',
  styleUrls: ['./file-temporal-browser.component.scss']
})
export class FileTemporalBrowserComponent implements OnInit {

  @Input()  files: File[] = [];
  @Input()  PanelTitle:   string;
  @Output() FileDeleted:  EventEmitter<any> = new EventEmitter();
  @Input()  IsDeleted: boolean = true;
  date = new Date();
  constructor(public dateHelper: DateHelper, private router: Router) {
    console.log(this.files)
  }

  ngOnInit()
  {

  }


  getIcon(file: any): string {
    let iconclass = 'fas fa-file-alt';
    const ext = this.getFileExtension(file, 'name');
    if (ext === '.pdf') {
      iconclass = 'fas fa-file-pdf text-danger';
    } else if (ext === '.docx' || ext === '.doc') {
      iconclass = 'fas fa-file-word text-primary';
    }
    iconclass += ' fa-5x';
    return iconclass;
  }


  downloadFile(file: File) {
    
    const url = window.URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = url;
    a.download = file.name;
    a.click();

    window.URL.revokeObjectURL(url);
  }

  FileDelete(i: any) {
    this.FileDeleted.emit(i);
  }

  getFileExtension(file: any, propertyName: string) {
    return file[propertyName].split('.').pop().toLowerCase();
  }

  getDownloadUrl(file: File): string {
    const url = window.URL.createObjectURL(file);
    return url;
  }
}
